import { render, staticRenderFns } from "./SessionViewDetails.vue?vue&type=template&id=4c119cac&"
import script from "./SessionViewDetails.vue?vue&type=script&lang=js&"
export * from "./SessionViewDetails.vue?vue&type=script&lang=js&"
import style0 from "./SessionViewDetails.vue?vue&type=style&index=0&id=4c119cac&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports